module.exports = __webpack_public_path__ + "static/media/Google-Scholar.16a8b081.png";